import React,{Component} from 'react';
import "./style.less";
import {NavBar,Toast,ListView,Icon,Modal} from "antd-mobile";
import {connect} from "react-redux";
import {goodsList,receiving,debus} from "../../../service/shiftService";
let pageIndex = 1;
let pageSize = 10;
const dataError = require('../../../common/image/wrongData.png');
const noOrder = require('../../../common/image//noOrder.png');
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class BringGoodsList extends Component{
    constructor(props) {
        super(props);
        const dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });
        this.state = {
            OrderListData:[],
            dataSource,
            showModal:false,
            isLoading: true,
            notDataLoading:0,
            type:'',
            id:'',
        }
    };
    componentDidMount() {
        pageIndex = 1;
        let params={
            token: this.props.userInfo.token,
            data:{
                pageSize: pageSize,
                pageNum: 1,
                shiftId:this.props.location.state.id
            }
        };
       this._getOrderList(params);
    }
    _getOrderList(params){
        goodsList(params).then((res) => {
                if(res.data.code == "0000"){
                    console.log(res)
                    if (res.data.data.list.length > 0) {
                        this._setDataSource(res.data.data);
                        // this.setState({data:res.data.data.list})
                    }else{
                        this.setState({isLoading: false,notDataLoading:1});
                    }
                }else {
                    this.setState({notDataLoading:2,isLoading: false});
                    Toast.info(res.data.msg,3)
                }
            }).catch(function (error) {
            console.log(error);
        });
    };
     //数据拼接
     _setDataSource(data) {
        const allData = [...this.state.OrderListData, ...data.list];
        this.setState({
            dataSource:this.state.dataSource.cloneWithRows(allData),
            OrderListData: allData,
        });
        if (pageIndex * pageSize >= data.total) {
            this.setState({isLoading: false});
        }
    }
    //上拉加载
    _onEndReached = () => {
        if (this.state.isLoading) {
            let params = {
                token: this.props.userInfo.token,
                data:{
                    pageSize: pageSize,
                    pageNum: ++pageIndex
                },
            };
            this._getOrderList(params);
        }
    };
    notData(){
        if(this.state.notDataLoading == 1){
            return <div className="noData">
                        <img src={noOrder} />
                        <p>暂无数据</p>
                    </div>
        }else if(this.state.notDataLoading == 2){
            return <div className="noData">
                <img src={dataError} />
                <p>数据出错，请稍后再试！</p>
            </div>
        }else{
            return null
        }
    }
   
    status(res){
        if(res == 0){
            return '待支付'
        }
        if(res == 1){
            return '待出行'
        }
        if(res == 2){
            return '行程中'
        }
        if(res == 3){
            return '已完成'
        }
        if(res == 99){
            return '已关闭'
        }
    }
    operation = () =>{
        let params = {
            "token": this.props.userInfo.token,
            "data":{
                "id": this.state.id
            }
         };
         let postr = this.state.type=== 'quhuo'?  receiving : debus
        //  console.log(params,postr)
        //  return
         postr(params)
             .then((res) => {
                 console.log(res)
                 if (res.data.code === '0000') {
                    Toast.info('操作完成！');
                    setTimeout(() => {
                        window.location.reload()
                    }, 2000);
                 }
                 else if (res.data.code === '1401') {
                    document.location = `js://toLogin?token=${this.props.userInfo.token}`;
                 }
                 else {
                     Toast.info(res.data.msg);
                 }
             }).catch(function (error) {
             console.log(error);
         });
    };
    render(){
        const _renderRow = (i, index, rowID) => (
            <div className="list" key={rowID}>
                <div className="top">
                    <span>订单号  {i.orderNum}</span>
                    <span>{this.status(i.status)}</span>
                </div>
                <div className="middle">
                    <div className="body">
                        <div>{i.logisticsType}&nbsp;&nbsp;&nbsp;{i.logisticsWeight}kg</div>
                        <div className='orange'>{i.price}元</div>
                    </div>
                    <div>寄：{i.senderPhone}&nbsp;&nbsp;&nbsp;收：{i.recipientsPhone}</div>
                    <div className="padding10">{i.description}</div>
                </div>
               {/*  <div className="bottom">
                {i.status === 1 ? 
                    <div><button className='shouhuo' onClick={()=>this.setState({showModal:true,type:'quhuo',id:i.id})}>确认取货</button></div>: 
                    i.status === 2 ?  <div><button onClick={()=>this.setState({showModal:true,type:'songda',id:i.id})} className='songda'>确认送达</button></div>: null}
                </div> */}
            </div>
        )
        return(
            <div className="bringGoodsList">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()} />}
                >带货订单</NavBar>
                <div className="content">
                    {this.notData()}
                    {
                        this.state.notDataLoading == 0  ?
                            <ListView
                                ref={el => this.lv = el}
                                dataSource={this.state.dataSource}
                                renderFooter={() => (this.state.isLoading ? <Icon type="loading"/> : '没有更多')}
                                renderRow={_renderRow}
                                style={{
                                    height: '100%',
                                    overflow:'auto'
                                }}
                                onEndReached={this._onEndReached.bind(this)}
                                scrollRenderAheadDistance={300}
                                onEndReachedThreshold={30}
                            />: null
                    }        
                    <Modal
                    className="combineBillViewModal"
                    visible={this.state.showModal}
                    transparent
                    maskClosable={false}
                    footer={[{ text: '取消', onPress: () => { this.setState({showModal:!this.state.showModal}); } },{ text: '确定', onPress: () => { this.setState({showModal:!this.state.showModal});this.operation() } }]}
                >
                    {
                        this.state.type === 'quhuo' ?
                        <div className="modalTitle">
                            <div>是否确认取货？</div>
                            <div>请确认已经取到相应的货物并装车！</div>
                        </div>
                        :                    
                        <div className="modalTitle">
                            <div>是否确认送达？</div>
                            <div>请确认货物已经交付给收件人，已核实收件人手机号及提货短信!</div>
                        </div>

                    }
                  
                </Modal> 
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Shift/BringGoodsList/index.js